export default {
  namespaced: true,
  state: {
    exception: { message: '' },
  },
  mutations: {
    SET_EXCEPTION(state, message) {
      state.exception.message = message
    },
  },
  getters: {
    exception(state) {
      return state.exception
    },
  },
  actions: {
    newException({ commit }, message) {
      commit('SET_EXCEPTION', message)
    },
  },
}
